var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraduation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0962 12.2872C24.2976 12.1983 24.4685 12.0523 24.5877 11.8673C24.707 11.6823 24.7693 11.4664 24.767 11.2462C24.7648 11.0261 24.698 10.8115 24.5749 10.629C24.4519 10.4465 24.278 10.3041 24.0748 10.2194L14.4324 5.82741C14.1393 5.69371 13.8209 5.62451 13.4987 5.62451C13.1765 5.62451 12.8581 5.69371 12.5649 5.82741L2.92367 10.2149C2.72339 10.3026 2.553 10.4468 2.43336 10.6298C2.31372 10.8128 2.25 11.0268 2.25 11.2454C2.25 11.4641 2.31372 11.678 2.43336 11.861C2.553 12.044 2.72339 12.1882 2.92367 12.2759L12.5649 16.6724C12.8581 16.8061 13.1765 16.8753 13.4987 16.8753C13.8209 16.8753 14.1393 16.8061 14.4324 16.6724L24.0962 12.2872Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 11.25V18",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 14.0625V18C6.75 18.8951 7.46116 19.7536 8.72703 20.3865C9.9929 21.0194 11.7098 21.375 13.5 21.375C15.2902 21.375 17.0071 21.0194 18.273 20.3865C19.5388 19.7536 20.25 18.8951 20.25 18V14.0625",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduation);
export default __webpack_public_path__ + "static/media/graduation.ebe6865fe8eef70196791e8c420c7b3f.svg";
export { ForwardRef as ReactComponent };